import { Edit, TabbedForm } from 'react-admin';
import SummaryTab from './Forms/SummaryTab';
import EditToolbar from '../../Components/EditToolbar';
import { AffiliateNetworkResource } from '../../Entities/AffiliateNetwork';
import { ReactElement } from 'react';

export default function AffiliateEdit(): ReactElement {
  return (
    <Edit<AffiliateNetworkResource> mutationMode="pessimistic">
      <TabbedForm toolbar={<EditToolbar />}>
        <SummaryTab />
      </TabbedForm>
    </Edit>
  );
}
